<div class="tool d-flex align-items-center" [class]="toolClass">
  <i class="emp-icon me-2" title="{{ toolPanelMinimised ? meta.title : '' }}" [ngClass]="meta.icon"></i>
  <div class="flex-grow-1">
    <span *ngIf="!toolPanelMinimised" class="tool-title eyfontbold">{{ meta.title }}</span>
  </div>
  <i [title]="'Click and drag to add a Tool to the flow'" *ngIf="!toolPanelMinimised" class="emp-icon icon-ico_dnd ps-10"></i>
</div>
